/* eslint no-template-curly-in-string: 0 */
import { FLOW_TYPES, PAYMENT_STATUSES } from "../../../../utils/enums";

export const starbucks = {
  id: "EGIFT_BLACKHAWK_STARBUCKS",
  displayName: "Starbucks",
  paymentFlow: "email",
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "Desde 1971, la empresa de café Starbucks® se ha comprometido a obtener y tostar de forma ética el café arábigo de mayor calidad del mundo. Actualmente, con tiendas en todo el mundo, la compañía es la principal torrefactora y minorista de café especial del mundo. Para compartir la experiencia, visítenos en nuestras tiendas o en línea en <a href=\"https://www.starbucks.com\"www.starbucks.com</a>.<br/><br/>Términos de la tarjeta electrónica de regalo de Starbucks>: Trate esta tarjetacomo si fuera dinero en efectivo. Recargue su tarjeta, revise su saldo y averigüe cómo registrar y proteger el saldo de tu tarjeta en las tiendas participantes, <a href=\"https://www.starbucks.com\"Starbucks.com</a>> o <a href=\"tel:+1-800-782-7282\">1-800-782-7282</a>. No se puede canjear por dinero en efectivo a menos que lo exija la ley. Solo se reembolsan las tarjetas no utilizadas con el recibo original. Esta tarjeta no caduca, ni Starbucks cobra comisiones. Los términos y condiciones completos están disponibles en nuestro sitio web. El uso de esta tarjeta constituye la aceptación de estos términos y condiciones.",
          question: "Acerca de la tarjeta electrónica de regalo de Starbucks®"
        }
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        {
          answer: "Desde 1971, la empresa de café Starbucks® se ha comprometido a obtener y tostar de forma ética el café arábigo de mayor calidad del mundo. Actualmente, con tiendas en todo el mundo, la compañía es la principal torrefactora y minorista de café especial del mundo. Para compartir la experiencia, visítenos en nuestras tiendas o en línea en <a href=\"https://www.starbucks.com\"www.starbucks.com</a>.<br/><br/>Términos de la tarjeta electrónica de regalo de Starbucks>: Trate esta tarjetacomo si fuera dinero en efectivo. Recargue su tarjeta, revise su saldo y averigüe cómo registrar y proteger el saldo de tu tarjeta en las tiendas participantes, <a href=\"https://www.starbucks.com\"Starbucks.com</a>> o <a href=\"tel:+1-800-782-7282\">1-800-782-7282</a>. No se puede canjear por dinero en efectivo a menos que lo exija la ley. Solo se reembolsan las tarjetas no utilizadas con el recibo original. Esta tarjeta no caduca, ni Starbucks cobra comisiones. Los términos y condiciones completos están disponibles en nuestro sitio web. El uso de esta tarjeta constituye la aceptación de estos términos y condiciones.",
          question: "Acerca de la tarjeta electrónica de regalo de Starbucks®"
        }
      ]
    }
  },
  paywall: {
    tile: {
      displayName: "Starbucks eGiftCard™",
      tagline: "Más del café y del té que le gusta",
      description: "Siga adelante con este pago",
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparando su Starbucks eGiftCard™"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    description: [
      "Ha elegido recibir una Starbucks eGiftCard de ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " que será enviada por correo electrónico a ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: "payment-recipientEmail"
        },
      },
      "."
    ],
  },
  paymentComplete: {
    initial: {
      description: [
        "¡Éxito! Por favor, revise su correo electrónico ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: "payment-recipientEmail"
          },
        },
        " para obtener más información con respecto a su ",
        {
          string: "Starbucks eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". Debería llegarle pronto e incluirá los detalles para su uso.",
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: "payment-updatedAt"
          },
        },
        ", un correo electrónico fue enviado a ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: "payment-recipientEmail"
          },
        },
        " con los detalles respecto a su ",
        {
          string: "Starbucks eGiftCard™",
          props: {
            className: "payment-paymentNetwork"
          },
        },
        " de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        "."
      ],
      secondaryText: "Por favor, considere esta tarjeta como si fuese dinero en efectivo y tenga el debido cuidado para evitar la pérdida o robo.",
    },
  }
};

export default starbucks;
